import React, { useState, useEffect } from "react";

const FPSBankStatementGenerateLink = ({
  month,
  year,
  allotMonth,
  allotYear,
  distCode,
  distMonthName,
  alotMonthName,
  districtName,
  bankDisplay,
  action,trigger
}) => {
  const [loading, setLoading] = useState(true);
  const [showMessageData, setShowMessageData] = useState({
    message: "",
    fileName: "", 
  });

  useEffect(() => {
  setShowMessageData({
    message: "",
    fileName: ""
  });
  setLoading(true);
   }, [trigger]);



  useEffect(() => {
    const generateTextFileName = async () => {
      setLoading(true);
      setShowMessageData({  message: "", fileName: "" }); 

      try {
        const params = {
          month,
          year,
          allotMonth,
          allotYear,
          distCode,
          distMonthName,
          alotMonthName,
          districtName,
          bankDisplay,
        };

        const queryParams = new URLSearchParams(params);

         let endpoint = "";

        if (action === "generate") {
          endpoint = "generate-text-file-name";
        } else if (action === "regenerate") {
          endpoint = "regenerate-text-file-name";
        } else {
          return; 
        }

        const response = await fetch(
          `${process.env.REACT_APP_URL}/api/commission/${endpoint}?${queryParams}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        const data = await response.json();
        setShowMessageData(data);
      } catch (error) {
        console.error("Fetch Error:", error);
        setShowMessageData({       
          message: "Something went wrong while fetching.",
          fileName: "",
        });
      } finally {
        setLoading(false);
      }
    };
    generateTextFileName();
  }, [
    action,
    month,
    year,
    allotMonth,
    allotYear,
    distCode,
    distMonthName,
    alotMonthName,
    districtName,
    bankDisplay   
  ]);

  return (
    <>
     <div id="container" style={{marginLeft:"-30px"}}>

      {!loading && showMessageData?.message && (
        <div
          className="mainhead"
          align="center"
          style={{ marginTop: "1px", marginBottom: "20px", textDecoration: "none" }}
        >
          {showMessageData.message}
        </div>
      )}

      {/* {!loading && showMessageData?.fileName && (
        <div style={{ textAlign: "center", marginTop: "10px", fontSize: "15px" }}>
        

          <a
            href={`${process.env.REACT_APP_URL}/api/commission/download-fps-summary?fn_name=${encodeURIComponent(
              showMessageData.fileName
            )}&dist_code=${distCode}&month=${month}&year=${year}&alotmonth=${allotMonth}&alotyear=${allotYear}&bankType=${bankDisplay}`}
          >
            {showMessageData.fileName}
          </a>


        </div>
      )} */}

        {!loading && showMessageData?.fileName && (() => {
        let endpoint;

        if (action === "generate") {
          endpoint = "download-fps-summary";
        } else if (action === "regenerate") {
          endpoint = "regenerate-download-fps-summary";
        } else {
          return null;
        }

        return (
          <div style={{ textAlign: "center", marginTop: "10px", fontSize: "15px" }}>
            <a
              href={`${process.env.REACT_APP_URL}/api/commission/${endpoint}?fn_name=${encodeURIComponent(
                showMessageData.fileName
              )}&dist_code=${distCode}&month=${month}&year=${year}&alotmonth=${allotMonth}&alotyear=${allotYear}&bankType=${bankDisplay}`}
            >
              {showMessageData.fileName}
            </a>
          </div>
        );
      })()}


      </div>
    </>
  );
};

export default FPSBankStatementGenerateLink;
